import React, { useMemo } from "react";

import styled from "styled-components";

import Dropdown from "components/atoms/Dropdown";
import Icon from "components/atoms/Icon";
import Tooltip from "components/atoms/Tooltip";
import { toolbarCommands } from "components/organisms/manuscript/editor/commands";

const MathMenuPopover = styled.div`
    padding: 6px;
    border: 1px solid #d8e1ec;
    border-radius: 8px;
    background: #ffffff;
    box-shadow: 0 12px 24px rgba(15, 23, 42, 0.12);
`;

const MathMenuList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
`;

const MathMenuItem = styled.button`
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    min-width: 160px;
    height: 32px;
    padding: 0 10px;
    border: 0;
    border-radius: 6px;
    background: transparent;
    color: #42576b;
    font-size: 12px;
    font-weight: 600;
    text-align: left;
    cursor: pointer;

    &:hover {
        background: #eef3f8;
    }
`;

function ManuscriptMathDropdown({
    Button,
    disabled,
    iconColor,
    runEditorCommand,
    onOpenMathOCR,
    open,
    onOpenChange,
    dropdownUsePortal = true,
}) {
    const options = useMemo(
        () => [
            {
                id: "inline",
                label: "인라인 수식",
                ariaLabel: "인라인 수식 삽입",
                icon: "mathInline",
                onSelect: () => runEditorCommand(toolbarCommands.wrapInInlineMath),
            },
            {
                id: "display",
                label: "블록 수식",
                ariaLabel: "블록 수식 삽입",
                icon: "mathBlock",
                onSelect: () => runEditorCommand(toolbarCommands.wrapInDisplayMath),
            },
            {
                id: "ocr",
                label: "이미지 인식",
                ariaLabel: "수식 이미지 인식",
                icon: "imageBlock",
                onSelect: () => onOpenMathOCR?.(),
            },
        ],
        [onOpenMathOCR, runEditorCommand],
    );

    const handleSelect = (option) => {
        onOpenChange(false);
        option.onSelect();
    };

    return (
        <Tooltip message="수식">
            <Dropdown
                open={open}
                onOpenChange={onOpenChange}
                placement="bottom-start"
                offset={6}
                anchor={
                    <Button
                        type="button"
                        onMouseDown={(event) => {
                            event.preventDefault();
                            event.stopPropagation();
                        }}
                        onClick={() => {
                            if (disabled) return;
                            onOpenChange(!open);
                        }}
                        disabled={disabled}
                        aria-label="수식 삽입"
                    >
                        <Icon name={"mathBlock"} size={"14px"} color={iconColor} />
                    </Button>
                }
                contentMinWidth="188px"
                usePortal={dropdownUsePortal}
            >
                <MathMenuPopover>
                    <MathMenuList role="menu">
                        {options.map((option) => (
                            <MathMenuItem
                                key={option.id}
                                type="button"
                                role="menuitem"
                                aria-label={option.ariaLabel}
                                onClick={() => handleSelect(option)}
                            >
                                <Icon name={option.icon} size={"12px"} color={"#42576b"} />
                                <span>{option.label}</span>
                            </MathMenuItem>
                        ))}
                    </MathMenuList>
                </MathMenuPopover>
            </Dropdown>
        </Tooltip>
    );
}

export default React.memo(ManuscriptMathDropdown);
